export default {
    header: {
        contact: 'Kontakt',
        items: [
            {
                caption: 'Leistungen',
                url: '#leistungen'
            },
            {
                caption: 'Energieausweis',
                url: '#energieausweis'
            },
            {
                caption: 'Sanierung',
                url: '#foerdermittel'
            },
            {
                caption: 'Neubau',
                url: '#neubau'
            },
            {
                caption: 'Baubegleitung',
                url: '#baubegleitung'
            },
        ],
    },
    top_section: {
        caption: 'Zukunft gestalten beginnt jetzt – gemeinsam mit uns',
        subtitle: 'Individuelle und geförderte Lösungen für Neubau und Sanierung, die langfristig wirken'
    },
    leistungen: {
        caption: 'Ihr Partner für nachhaltige Lösungen',
        items: [
            {
                icon: 'mdi-cash-multiple',
                caption: 'Energiekosten sparen',
                description: 'Wir helfen Ihnen, Ihre Energiekosten zu senken und Ihre Immobilie zukunftsfähig zu machen.'
            },
            {
                icon: 'mdi-earth',
                caption: 'Beitrag zum Klimaschutz',
                description: 'Durch energetische Sanierung leisten Sie einen wertvollen Beitrag zum Schutz von Klima und Umwelt.'
            },
            {
                icon: 'mdi-domain-plus',
                caption: 'Kompetente Beratung für Neubauprojekte',
                description: 'Als Experten im Raum Bremen begleiten wir Sie bei Neubauprojekten und der energetischen Aufwertung bestehender Gebäude.'
            },
            {
                icon: 'mdi-briefcase-check-outline',
                caption: 'Langjährige Erfahrung in der Bauwirtschaft',
                description: 'Profitieren Sie von unserer Expertise und unserer umfassenden Erfahrung in der Branche.'
            },
            {
                icon: 'mdi-handshake-outline',
                caption: 'Projektbegleitung bis zur Fördermaßnahme',
                description: 'Wir unterstützen Sie bei der gesamten Projektumsetzung – bis hin zur Beantragung von Fördermitteln.'
            },
            {
                icon: 'mdi-tune-variant',
                caption: 'Individuell abgestimmte Services',
                description: 'Unser Service passt sich genau Ihren Anforderungen und Zielen an, um die bestmögliche Lösung für Sie zu finden.'
            },
        ]
    },
    energieausweis: {
        caption: 'Der Energieausweis – zur energetischen Bewertung Ihrer Immobilie',
        items: [
            {
                icon: 'mdi-chart-bar',
                caption: 'Verbrauchsausweis',
                subitems: ['Basierend auf tatsächlichen Energieverbrauchsdaten', 'Spiegelt das individuelle Nutzungsverhalten wider', 'Einfach und kostengünstig', 'Für Gebäude mit Verbrauchsdaten der letzten 3 Jahre']
            },
            {
                icon: 'mdi-home-search-outline',
                caption: 'Bedarfsausweis',
                subitems: ['Technische Analyse des energetischen Gebäudezustands', 'Unabhängig vom Nutzerverhalten', 'Pflicht für Neubauten oder bei fehlenden Verbrauchsdaten', 'Rechtssicher & objektiv']
            }
        ],
        subtext: 'Beide Varianten erfüllen die dena-Standards und helfen bei der energetischen Optimierung Ihrer Immobilie.',
        button_to_contact_link: 'Jetzt Beratung anfordern'
    },
    sanierung: {
        caption: 'Mehr Förderung durch Planung: Ihr individueller Sanierungsfahrplan',
        subtitle: 'Strukturierte Planung, persönliche Beratung und optimale Förderung für Ihre energetische Sanierung.',
        items: [
            {
                icon: 'mdi-clipboard-list-outline',
                caption: 'Individueller Sanierungsfahrplan auf Basis Ihres Gebäudes'
            },
            {
                icon: 'mdi-account-voice',
                caption: 'Persönliche Beratung & verständliche Erläuterung'
            },
            {
                icon: 'mdi-cash-plus',
                caption: 'Direkte Förderung durch das BAFA'
            },
            {
                icon: 'mdi-home-analytics',
                caption: 'Mehr Förderung bei anschließenden Maßnahmen'
            },
            {
                icon: 'mdi-chart-timeline-variant',
                caption: 'Klarer Fahrplan für schrittweise Modernisierung'
            },
        ],
        bottom_left_caption: 'Aktuell interessieren Sie sich nur für eine geförderte Einzelmaßnahme?',
        bottom_left_content: 'Auch hier unterstützen wir Sie gerne bei der Umsetzung Ihres Projektes',
        button_to_contact_link: 'Jetzt Beratung anfordern'
    },
    neubau: {
        caption: 'Neubauprojekte mit Weitblick – Begleitung vom ersten Schritt an',
        items: [
            {
                icon: 'mdi-home-plus-outline',
                caption: 'Planung und Weichenstellung',
                description: 'Wir unterstützen Sie bei der Wahl der richtigen Anforderungen und Fördermöglichkeiten für Ihr Projekt.'
            },
            {
                icon: 'mdi-lightbulb-on-outline',
                caption: 'Know-how für Ihre Entscheidungen',
                description: 'Profitieren Sie von unserem Fachwissen bei komplexen Themen rund um Bau und Energieeffizienz.'
            },
            {
                icon: 'mdi-account-hard-hat',
                caption: 'Regelmäßige Qualitätssicherung',
                description: 'Mit Vor-Ort-Terminen stellen wir sicher, dass Ihr Bauvorhaben reibungslos und hochwertig verläuft.'
            },
            {
                icon: 'mdi-handshake-outline',
                caption: 'Fördermittel & Abwicklung',
                description: 'Wir übernehmen die Beantragung und Abwicklung von Fördermaßnahmen für Sie – stressfrei und vollständig.'
            }
        ],
        button_to_contact_link: 'Jetzt Beratung anfordern'
    },
    baubegleitung: {
        caption: 'Baubegleitung Schritt für Schritt',
        items: [
            {
                icon: 'mdi-lightbulb-outline',
                caption: 'Entscheidung zur Umsetzung',
                description: 'Sie haben sich für die energetische Modernisierung entschieden – wir stehen Ihnen ab diesem Moment zur Seite.'
            },
            {
                icon: 'mdi-file-document-edit-outline',
                caption: 'Fördermittel beantragen',
                description: 'Wir übernehmen die Abwicklung und Kommunikation mit BAFA und KfW – inklusive aller nötigen Formulare.'
            },
            {
                icon: 'mdi-clipboard-check-outline',
                caption: 'Dokumentation sichern',
                description: 'Alle Maßnahmen werden detailliert dokumentiert und gemäß Fördervorgaben vorbereitet.'
            },
            {
                icon: 'mdi-account-hard-hat',
                caption: 'Qualitätskontrolle vor Ort',
                description: 'Wir besuchen regelmäßig die Baustelle und stellen sicher, dass alles nach Plan läuft.'
            },
            {
                icon: 'mdi-handshake-outline',
                caption: 'Koordination mit Handwerk',
                description: 'Wir unterstützen Sie im Austausch mit den beauftragten Firmen – und helfen bei Engpässen mit unserem Netzwerk.'
            }
        ],
        button_to_contact_link: 'Jetzt Kontakt aufnehmen'
    },
    contact: {
        caption: 'Kontaktieren Sie uns',
        placeholder_name: 'Name',
        placeholder_email: 'E-Mail',
        placeholder_nachricht: 'Nachricht',
        send: 'Senden',
        email: 'info@dm-energieberatung.de',
        impressum: 'Impressum',
        datenschutz: 'Datenschutzerklärung',
        formularSendCaption: 'Vielen Dank für Ihre Nachricht!',
        formularSendContent: 'Wir werden uns schnellstmöglich bei Ihnen melden.',
        sendAnotherMailButton: 'Weitere Nachricht senden',
        sendMailError: 'Leider ist beim Versenden Ihrer Nachricht ein Fehler aufgetreten.<br>Bitte senden Sie Ihre Anfrage alternativ direkt per E-Mail an <a href="mailto:info@dm-energieberatung.de">info@dm-energieberatung.de</a>.<br>Vielen Dank für Ihr Verständnis!'
    },
    impressum: {
        back_to_home_link: 'Zurück zur Hauptseite',
        caption: 'Impressum',
        paragraph_information: 'Angaben gemäß § 5 DDG',
        company: 'D&M Engineering GmbH',
        address: 'Malottenweg 2',
        location: '27239 Twistringen',
        city: 'Twistringen',
        plz: '27239',
        phone: '+49151 29186534',
        country_short: 'DE',
        country: 'Deutschland',
        represented_by_label: 'Vertreten durch',
        represented_by_content: 'Tobias Diedrichs<br>Andre Marischen',
        contact: 'Kontakt',
        email_label: 'E-Mail',
        email_content: 'info@dm-energieberatung.de',
        register_entry: 'Registereintrag',
        entry_in_commercial_register: 'Eingetragen im Handelsregister B beim Amtsgericht Walsrode',
        registry_court_label: 'Registergericht',
        registry_court_content: 'Amtsgericht Bremen',
        register_number_label: 'Registernummer',
        register_number_content: 'HRB 212881',
        vat_id_label: 'Umsatzsteuer-ID',
        vat_id_content: 'DE363958641',
        supervisory_authority_label: 'Aufsichtsbehörde',
        supervisory_authority_content: '(Hier zuständige Behörde eintragen, z.B. BAFA oder Handwerkskammer)',
        liability_for_content_label: 'Haftung für Inhalte',
        liability_for_content_content: 'Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.<br>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.Eine entsprechende Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.',
        liability_for_links_label: 'Haftung für Links',
        liability_for_links_content: 'Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.<br>Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.',
        copyright_label: 'Urheberrecht',
        copyright_content: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.<br>Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.',
    },
    datenschutz: {
        back_to_home_link: 'Zurück zur Hauptseite',
        privacy_policy_label: 'Datenschutzerklärung',
        privacy_policy_content: 'Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, DDG). In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.',
        contact_us_label: 'Kontakt mit uns',
        contact_us_content: 'Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.',
        your_rights_label: 'Ihre Rechte',
        your_rights_content: 'Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der Aufsichtsbehörde beschweren.',
        cookies_label: 'Cookies',
        cookies_content: 'Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an. Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten.',
        web_analytics_label: 'Web-Analyse',
        web_analytics_content: 'Unsere Website verwendet Funktionen eines Webanalysedienstes. Dazu werden Cookies verwendet, die eine Analyse der Benutzung der Website durch Ihre Benutzer ermöglicht. Die dadurch erzeugten Informationen werden auf den Server des Anbieters übertragen und dort gespeichert. Sie können dies verhindern, indem Sie Ihren Browser so einrichten, dass keine Cookies gespeichert werden.',
        use_of_google_services_label: 'Verwendung von Google-Diensten',
        use_of_google_services_content: 'Diese Website kann Google Fonts, Google Maps oder YouTube-Videos einbinden. Beim Aufruf dieser Inhalte kann es zur Übermittlung personenbezogener Daten wie Ihrer IP-Adresse an Google-Server kommen. Bitte beachten Sie die Datenschutzerklärungen von Google.',
        responsible_person_label: 'Verantwortlicher',
        responsible_person_content: 'Diedrichs & Marischen Holzbau eGbR<br>Malottenweg 2<br>27239 Twistringen<br>E-Mail: info@dm-energieberatung.de',
        changes_label: 'Änderungen',
        changes_content: 'Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen.',
    }
}